export class DisputeCaseObject {
    ObjectType!: String;
    ObjectKey!: String;
    
    constructor() {
        this.ObjectKey = "";
        this.ObjectType = "";
    }
}

export class DisputeRequest {
    CADisputeType?: String;
    BusinessPartner: String;
    DisputedAmount: Number;
    DisputeCaseCurrency: String;
    CADisputeExternalCallerCode: String;
    ContractAccount: String;
    CasePriority?: String;
    CaseReason?: String;
    CaseNoteText: String;
    InvoiceNumber: String;
    _CACaseObject: Array<DisputeCaseObject>;

    constructor() {
        this.CADisputeType = "";
        this.BusinessPartner = "";
        this.DisputedAmount = 0;
        this.DisputeCaseCurrency = "";
        this.CADisputeExternalCallerCode = "";
        this.ContractAccount = "";
        this.CasePriority = "";
        this.CaseReason = "";
        this.CaseNoteText = "";
        this._CACaseObject = [];
        this.InvoiceNumber = "";
    }
}